import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import useLogin from "../../hooks/useLogin";
import { getUserFromToken } from "../../utils/authorizationUtil";
import DangerIcon from "../Shared/DangerIcon/DangerIcon";
import { Loader } from "@shltelemedicine/shl-ui-lib";
type SsoLoginProps = {
  token: string;
};

const SsoLogin = ({ token }: SsoLoginProps) => {
  const [userName, setUserName] = useState("");

  const { login, loginFailureReason } = useLogin();

  useEffect(() => {
    (async () => {
      const tokenUser = getUserFromToken(token);
      setUserName(tokenUser?.UserName ?? "");

      await login(tokenUser?.UserName ?? "", "", token);
    })();
  }, [login, token]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center p-2">
      {token && !loginFailureReason ? (
        <Loader
          message={
            <>
              <p className="mb-0">
                <FormattedMessage id="GLOBAL.HELLO" defaultMessage="Hello" />,
              </p>
              {userName && (
                <p className="mb-1">
                  <b>{userName}</b>
                </p>
              )}
              <p className="mb-2">
                <FormattedMessage
                  id="SSO_LOGIN.PLEASE_WAIT"
                  defaultMessage="Please wait while we try to sign you in"
                />
              </p>
            </>
          }
          messagePosition="top"
        />
      ) : (
        <p className="mb-0 d-flex align-items-center">
          <DangerIcon className="mx-2" />
          <FormattedMessage
            id="SSO_LOGIN.UNABLE_TO_LOGIN"
            defaultMessage="Unable to sign you in, please try again later"
          />
        </p>
      )}
    </div>
  );
};

export default SsoLogin;
